module.exports = __webpack_public_path__ + "static/media/p1_product.9db76fab.png";